import React, { useEffect, useMemo, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../FormulaGenerator/Formula3DPreview";
import { bridgeProsthetics, bridgeProstheticsSwitchers, compositeRestorations, compositeRestorationsSwitchers, crowns, crownsSwitchers, fullRemovableProsthetics, fullRemovableProstheticsSwitchers, implantation, implantationSwitchers, removableProsthetics, removableProstheticsSwitchers, totalImplantation, totalImplantationSwitchers, veneers, veneersSwitchers } from "./screenSaverSetUps";
import leftBanner from "./images/leftSideBanner.png";
import { TranslateProvider, useTranslation } from "../i18n";

const ScreenSaver = ({
  isShow,
  onClose,
  langCode = "en"
}) => {
  const {
    _t,
    setLanguage
  } = useTranslation();
  useEffect(() => {
    setLanguage(langCode);
  }, [langCode, setLanguage]);
  const [currentType, setCurrentType] = useState("implantation");
  const typesList = [{
    name: _t("Имплантация"),
    key: "implantation",
    preview: require("./images/implantation.png")
  }, {
    name: _t("Тотальная имплантация"),
    key: "totalImplantation",
    preview: require("./images/total-implantation.png")
  }, {
    name: _t("Виниры"),
    key: "veneers",
    preview: require("./images/veneers.png")
  }, {
    name: _t("Коронки"),
    key: "crowns",
    preview: require("./images/crowns.png")
  }, {
    name: _t("Композитные реставрации"),
    key: "compositeRestorations",
    preview: require("./images/composite-restorations.png")
  }, {
    name: _t("Мостовидное протезирование"),
    key: "bridgeProsthetics",
    preview: require("./images/bridge-prosthetics.png")
  }, {
    name: _t("Съемное протезирование"),
    key: "removableProsthetics",
    preview: require("./images/removable-prosthetics.png")
  }, {
    name: _t("Полное съемное протезирование"),
    key: "fullRemovableProsthetics",
    preview: require("./images/full-removable-prosthetics.png")
  }];
  const {
    currentSetUp,
    availableSwitchers
  } = useMemo(() => {
    switch (currentType) {
      case "implantation":
        return {
          currentSetUp: implantation,
          availableSwitchers: implantationSwitchers
        };

      case "totalImplantation":
        return {
          currentSetUp: totalImplantation,
          availableSwitchers: totalImplantationSwitchers
        };

      case "veneers":
        return {
          currentSetUp: veneers,
          availableSwitchers: veneersSwitchers
        };

      case "crowns":
        return {
          currentSetUp: crowns,
          availableSwitchers: crownsSwitchers
        };

      case "compositeRestorations":
        return {
          currentSetUp: compositeRestorations,
          availableSwitchers: compositeRestorationsSwitchers
        };

      case "bridgeProsthetics":
        return {
          currentSetUp: bridgeProsthetics,
          availableSwitchers: bridgeProstheticsSwitchers
        };

      case "removableProsthetics":
        return {
          currentSetUp: removableProsthetics,
          availableSwitchers: removableProstheticsSwitchers
        };

      case "fullRemovableProsthetics":
        return {
          currentSetUp: fullRemovableProsthetics,
          availableSwitchers: fullRemovableProstheticsSwitchers
        };

      default:
        return {
          currentSetUp: implantation,
          availableSwitchers: implantationSwitchers
        };
    }
  }, [currentType]);

  function formulaLoadedCallback() {}

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "screenSaver"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenSaver-leftBanner"
  }, /*#__PURE__*/React.createElement("img", {
    src: leftBanner,
    alt: ""
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "screenSaver-runButton",
    onClick: onClose
  }, _t("Создать индивидуальный план лечения")), /*#__PURE__*/React.createElement("div", {
    className: "screenSaver-types"
  }, /*#__PURE__*/React.createElement("div", {
    className: "screenSaver-types-list"
  }, typesList.map(el => /*#__PURE__*/React.createElement("div", {
    className: `screenSaver-types-list-item ${el.key === currentType ? "active" : ""}`,
    key: el.key,
    onClick: () => {
      setCurrentType(el.key);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: el.preview,
    className: "screenSaver-types-list-item-preview",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "screenSaver-types-list-item-title"
  }, el.name))))), /*#__PURE__*/React.createElement("div", {
    className: "screenSaver-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: currentSetUp,
    availableSwitchers: availableSwitchers,
    animate: true,
    hideNotUsedSides: false,
    cameraZoom: 0.07,
    onLoaded: formulaLoadedCallback
  })));
};

const ScreenSaverWrapper = props => {
  return /*#__PURE__*/React.createElement(TranslateProvider, null, /*#__PURE__*/React.createElement(ScreenSaver, props));
};

export default ScreenSaverWrapper;